<div class="relative">
    <ng-container *ngIf="allegati$ | async as allegati">
      <ng-container *ngIf="objectKeys(allegati).length; else noAllegati">
        <ng-container *ngFor="let key of objectKeys(allegati); trackBy: trackByKey">
          <ng-container *ngIf="allegati[key]?.length">

          <div class=" border border-t-2 border-primary rounded mb-1">
            <div class="z-10 sticky top-0 -mt-px px-6 py-2 border-t border-b-2 uppercase bg-gray-50 dark:bg-gray-900">
              <div class="flex items-start justify-start py-1">

                <mat-icon class="icon-size-5 mr-2" [svgIcon]="'feather:file'"></mat-icon>

                <p class="text-base font-semibold">{{ allegati[key][0].field_title }}</p>

                <!-- ddsdsdsdsds -->

              </div>
            </div>

            <ng-container *ngFor="let allegato of allegati[key]; let i = index; trackBy: trackByFn">
              <div class="z-20 flex items-center px-3 py-4 md:px-2 cursor-pointer border-b">
                <div class="">
                  <div class="font-medium leading-5 items-center flex justify-center">
                    <mat-icon svgIcon="file_present" class="mr-2" (click)="apriFile(allegato.file_id, allegato.file_name)"></mat-icon>

                    <p class="text-md"> {{ allegato.file_name }} ({{ allegato.file_id }}) </p>

                    <div class="ml-2.5 gap-x-1 flex flex-row">
                        <mat-icon class="cursor-pointer icon-size-5" (click)="scaricaFile(allegato.file_id, allegato.file_name)">get_app</mat-icon>
                    </div>
                </div>
                </div>
              </div>
            </ng-container>
          </div>

          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- No allegati -->
    <ng-template #noAllegati>
      <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center">Non sono presenti allegati!</div>
    </ng-template>
  </div>
